<div class="flex h-full" #mobileNav>
  <p-slideMenu class="flex-grow-1"
               [model]="menuItems"
               [menuWidth]="mobileNav.offsetWidth"
               [viewportHeight]="mobileNav.offsetHeight"
               [style]="{ width: '100%', height: '100%' }">
  </p-slideMenu>
</div>
